var React = require('react');

function CheckmarkForms (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.936053 7.29067L5.55145 10.4402L11.8505 1.20942","stroke":"#FFFFFE","strokeWidth":"2"}));
}

CheckmarkForms.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = CheckmarkForms;

CheckmarkForms.default = CheckmarkForms;
